import { createReducer } from "@reduxjs/toolkit";
import { set, lensPath } from "ramda";
import { setEducationalTrainingModules } from "../actions/trainingModules";
const initialState = {};
const educationalTrainingModules = createReducer(initialState, {
    [setEducationalTrainingModules.type]: (state, action) => set(lensPath([action.payload.pk, "eduModules"]), action.payload.eduModules, state),
});
export default educationalTrainingModules;
